/* eslint-disable */

// @ts-nocheck
import { isPlainObject } from 'is-plain-object';

import { CUSTOM_METRICS } from '@utils/owlReporter';

/**
 * 订单小票打印xml模板->打印接口
 *
 * @creator zhoubingqing
 * @date 2016-02-01
 *
 * 🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨
 *
 * 本文件已获得【五年陈】认证
 * 此次订单迁移仅对import/export，以及必要的工具类进行改造
 *
 * 🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨
 *
 */

import Mustache from 'mustache';

function trim(str) {
    return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}

const multiply = function(arg1, arg2) {
    var m = 0,
        s1 = arg1.toString(),
        s2 = arg2.toString();
    try {
        m += s1.split('.')[1].length;
    } catch (e) {}
    try {
        m += s2.split('.')[1].length;
    } catch (e) {}
    return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m);
};

// 返回若干个特定字符组成的字符串
var getCharString = function(char, length) {
    var arr = [],
        length = Math.floor(length);
    while (length-- > 0) {
        arr.push(char);
    }
    return arr.join('');
};

// 判断是否奇数
var ifOdd = function(num) {
    if (num % 2 === 1) return true;
    else return false;
};

// 计算字符串宽度
var calcuStringWidth = function(str) {
    var width = (len = str.length);
    for (var i = 0; i < len; i++) {
        if (str.charCodeAt(i) >= 255) width++;
    }
    return width;
};

// 按需要的宽度将字符串切分成两部分，返回两部分的值
var cutString = function(str, width) {
    var w = 0,
        len = str.length;
    for (var i = 0; i < len; i++) {
        if (str.charCodeAt(i) >= 255) w += 2;
        else w += 1;
        if (w > width) break;
    }
    return [str.substr(0, i), str.substr(i)];
};

var xmlToPrinter = {
    _alignStyle: {
        left: 'L',
        center: 'C',
        right: 'R',
    },

    _fontStyle: {
        B: 'DHW',
        W: 'DW',
        H: 'DH',
        D: 'CHW',
    },

    _getXmlDoc: function(xml) {
        var txt = xml.replace(/&nbsp;/g, '/blank');
        var parser, xmlDoc;

        if (window.DOMParser) {
            parser = new DOMParser();
            xmlDoc = parser.parseFromString(txt, 'text/xml');
        } else {
            // Internet Explorer
            xmlDoc = new ActiveXObject('Microsoft.XMLDOM');
            xmlDoc.async = 'false';
            xmlDoc.loadXML(txt);
        }

        return xmlDoc;
    },

    _ifLeafNode: function(node) {
        var cNodes = node.childNodes,
            len = cNodes.length;
        if (len === 0) return true;
        else return false;
    },

    _printNode: function(node, p, charWidth) {
        switch (node.nodeName) {
            case 'br':
                //p.ptsl(' ', charWidth);
                p.ptl('\n');
                break;
            case 'line':
                p.ptsl(node.getAttribute('chars') || '-', charWidth);
                break;
            case 'div':
                var styles = [],
                    align = node.getAttribute('align'),
                    font = node.getAttribute('font');
                align ? styles.push(this._alignStyle[align]) : '';
                font ? styles.push(this._fontStyle[font]) : '';
                if (!this._ifLeafNode(node)) {
                    var cNodes = node.childNodes,
                        nodeCnt = cNodes.length,
                        cPNdoes = [];

                    for (var i = 0; i < nodeCnt; i++) {
                        if (
                            (cNodes[i].nodeName === 'span' && cNodes[i].childNodes.length > 0) ||
                            (cNodes[i].nodeName === '#text' && trim(cNodes[i].nodeValue) !== '')
                        ) {
                            cPNdoes.push(cNodes[i]);
                        }
                    }

                    nodeCnt = cPNdoes.length;
                    for (var i = 0; i < nodeCnt; i++) {
                        if (cPNdoes[i].nodeName === 'span') {
                            var cFont = cPNdoes[i].getAttribute('font');
                            var cStyles = cFont ? styles.concat(this._fontStyle[cFont]) : styles;
                            var cStyle = cFont ? this._fontStyle[cFont] : '';
                            var nodeValue = trim(cPNdoes[i].childNodes[0].nodeValue).replace(
                                /\/blank/g,
                                ' ',
                            );
                            if (i === nodeCnt - 1) p.ptl(nodeValue, cStyles.join(','));
                            else p.pt(nodeValue, cStyle);
                        } else if (cPNdoes[i].nodeName === '#text') {
                            var nodeValue = trim(cPNdoes[i].nodeValue);
                            if (i === nodeCnt - 1) p.ptl(nodeValue, styles.join(','));
                            else p.pt(nodeValue);
                        }
                    }
                }
                break;
            case 'tr':
                //文字样式
                var font = node.getAttribute('font'),
                    font = font ? this._fontStyle[font] : '';
                //遍历td，获取每列的内容和宽度、居中样式，存入数组中
                var tds = [],
                    cNodes = node.childNodes,
                    nodeCnt = cNodes.length;
                for (var i = 0; i < nodeCnt; i++) {
                    if (cNodes[i].nodeName === 'td') {
                        var cWidth = (cNodes[i].getAttribute('width') * charWidth) / 32,
                            cAlign = cNodes[i].getAttribute('align'),
                            cValue =
                                cNodes[i].childNodes.length > 0 && cNodes[i].childNodes[0].nodeValue
                                    ? cNodes[i].childNodes[0].nodeValue.replace(/[\s\r\n]/g, '')
                                    : '';
                        tds.push({
                            value: cValue,
                            width:
                                font === 'DHW' || font === 'DW'
                                    ? Math.round(cWidth / 2)
                                    : Math.round(cWidth),
                            align: cAlign ? cAlign : 'left',
                        });
                    }
                }
                //循环处理每一行，结束条件是每列剩余的内容宽度都<=列宽
                var tdNum = tds.length;
                while (1) {
                    for (var i = 0; i < tdNum; i++) {
                        var strs = cutString(tds[i].value, tds[i].width);
                        var showValue = strs[0],
                            printValue = '';

                        switch (tds[i].align) {
                            case 'left':
                                printValue =
                                    showValue +
                                    getCharString(' ', tds[i].width - calcuStringWidth(showValue));
                                break;
                            case 'center':
                                var allWidth = tds[i].width - calcuStringWidth(showValue),
                                    leftWidth = ifOdd(allWidth) ? (allWidth - 1) / 2 : allWidth / 2,
                                    rightWidth = ifOdd(allWidth)
                                        ? (allWidth + 1) / 2
                                        : allWidth / 2;
                                printValue =
                                    getCharString(' ', leftWidth) +
                                    showValue +
                                    getCharString(' ', rightWidth);
                                break;
                            case 'right':
                                printValue =
                                    getCharString(' ', tds[i].width - calcuStringWidth(showValue)) +
                                    showValue;
                                break;
                            default:
                                break;
                        }

                        if (i === tdNum - 1) p.ptl(printValue, font);
                        else p.pt(printValue, font);

                        tds[i].value = strs[1];
                    }

                    for (var i = 0; i < tdNum; i++) {
                        if (tds[i].value !== '') break;
                    }
                    if (i === tdNum) break;
                }
                break;
            default:
                break;
        }
    },

    printXml: function(xml, p, charWidth) {
        var xmlDoc = this._getXmlDoc(xml);
        var node = xmlDoc.getElementsByTagName('print')[0],
            cNodes = node.childNodes,
            len = cNodes.length;
        for (var i = 0; i < len; i++) {
            this._printNode(cNodes[i], p, charWidth);
        }
    },
};

var printVoToStandard = function(order) {
    return {
        time: order.order_time_fmt,
        poiName: order.poi_name,
    };
};

var jsonToXml = function(order, wmPoiId) {
    //var order = {"actual_pay_type":2,"apply_reason":"","apply_refund_type":1,"bookmark":true,"boxpriceTotal":0,"cancel_reason":"","cartCount":1,"cartDetailVos":[{"cartAmount":40,"cartName":"1号口袋","details":[{"box_num":0,"box_price":0,"cart_id":0,"count":1,"discountInfo":"","food_name":"蛋黄鲜肉粽160g","food_price":111.11,"locator_code":"","source_food_code":"","unit":"份","upc_code":""},{"box_num":0,"box_price":0,"cart_id":0,"count":2,"discountInfo":"","food_name":"五芳大肉粽160g","food_price":6,"locator_code":"","source_food_code":"","unit":"份","upc_code":""},{"box_num":0,"box_price":0,"cart_id":0,"count":2,"discountInfo":"","food_name":"红烧排骨粽160g","food_price":7,"locator_code":"","source_food_code":"","unit":"份","upc_code":""}]}],"caution":"","delivery_btime":0,"delivery_btime_fmt":"02-24 15:01","details":[{"box_num":0,"box_price":0,"cart_id":0,"count":1,"discountInfo":"","food_name":"蛋黄鲜肉粽160g","food_price":111.11,"locator_code":"","source_food_code":"","unit":"份","upc_code":""},{"box_num":0,"box_price":0,"cart_id":0,"count":2,"discountInfo":"","food_name":"五芳大肉粽160g","food_price":6,"locator_code":"","source_food_code":"","unit":"份","upc_code":""},{"box_num":0,"box_price":0,"cart_id":0,"count":2,"discountInfo":"","food_name":"红烧排骨粽160g","food_price":7,"locator_code":"","source_food_code":"","unit":"份","upc_code":""}],"deviceType":4,"discounts":[{"category":0,"hiddenType":0,"info":"-12.0","type":"满40.0元减12.0元。"},{"category":0,"hiddenType":0,"info":"-4.0","type":"用户使用了支付红包减4元"}],"dispatch_code":"","dispatcherName":"","dispatcherPhone":"","expireTime":"","id":947241404,"invoice_title":"","is_cross_day_pre_order":0,"is_pre_order":0,"newGuest":true,"online_paid_info":"","order_source":6,"order_source_desc":"","order_time":1456129676,"order_time_fmt":"02-22 16:27","overtime_paid_info":"","pay_status":3,"pay_status_desc":"已付款","pay_utime":1456129676,"pay_utime_fmt":"2016-02-22nbsp;16:27:56","people_count":0,"poi_name":"五芳斋(武林店)","pre_order_remind":0,"pre_order_tip":"预订单：期望送达时间","receiptHoler":1,"receiptType":1,"recipient_address":"凤起商务大厦(正门)nbsp;(2516室)","recipient_name":"陈女士","recipient_phone":"18258278131","reject_reason":"","shipping_fee":0,"shipping_time":"","status":2,"status_desc":"等待商家确认","tips":[],"total_after":99999,"total_before":40,"total_items":6,"type":0,"wm_order_id_view":6107062086652257,"wm_order_id_view_str":"6107062086652257","wm_order_pay_type":2,"wm_poi_id":610706,"wm_poi_order_dayseq":59};
    //找到该poi对应使用的模板id
    var poiPrintTemplates = JSON.parse(localStorage.getItem('poiPrintTemplates'));
    var templateId = 0;
    if (poiPrintTemplates) {
        for (var j = 0, len = poiPrintTemplates.length; j < len; j++) {
            if (poiPrintTemplates[j].wmPoiId === wmPoiId) {
                templateId = poiPrintTemplates[j].nowTemplateId;
            }
        }
    }
    var template = parent.PRINTTEMPLATES[templateId]; //--to do 如果没有读到获取本地存储的默认模板
    if (!template) {
        return {
            [CUSTOM_METRICS.PRINT_FAIL.TAGS.ERROR_CODE]:
                CUSTOM_METRICS.PRINT_FAIL.ERROR_CODE.PRINT_TEMPLATE_NOT_AVAILABLE,
            [CUSTOM_METRICS.PRINT_FAIL.TAGS.TEMPLATE_ID]: templateId,
        };
    }
    //匹配其中的#DEF equal和#DEF mul，在order对象中插入对应key
    var tempValue, r;

    var searchAndReplace = function(f1, f2, obj, newf, type) {
        if (isPlainObject(obj)) {
            if (type === 'mul') {
                if (
                    obj[f1] !== undefined &&
                    obj[f2] !== undefined &&
                    !isNaN(obj[f1]) &&
                    !isNaN(obj[f2])
                ) {
                    obj[newf] = multiply(obj[f1], obj[f2]);
                }
            } else if (type === 'equal') {
                if (obj[f1] !== undefined) {
                    if (obj[f1] + '' === f2) tempValue = true;
                    else tempValue = false;
                    obj[newf] = tempValue;
                }
            }

            for (var key in obj) {
                searchAndReplace(f1, f2, obj[key], newf, type);
            }
        } else if (Array.isArray(obj)) {
            for (var i = 0, len = obj.length; i < len; i++) {
                searchAndReplace(f1, f2, obj[i], newf, type);
            }
        }
    };

    var equalReg = /#DEF (([^\s]+)#equal#([^\s]+))/g;
    while ((r = equalReg.exec(template))) {
        searchAndReplace(r[2], r[3], order, r[1], 'equal');
    }

    var mulReg = /#DEF (([^\s]+)#mul#([^\s]+))/g;
    while ((r = mulReg.exec(template))) {
        searchAndReplace(r[2], r[3], order, r[1], 'mul');
    }

    var parseResult = '';

    try {
        parseResult = Mustache.render(template.substr(template.indexOf('<print>')), order);
    } catch (e) {
        if (window.Owl && window.Owl.addError) {
            window.Owl.addError(e);
        }
    }

    if (parseResult === '') {
        // 模板解析失败
        return {
            [CUSTOM_METRICS.PRINT_FAIL.TAGS.ERROR_CODE]:
                CUSTOM_METRICS.PRINT_FAIL.ERROR_CODE.RENDER_PRINT_TEMPLATE_FAIL,
            [CUSTOM_METRICS.PRINT_FAIL.TAGS.TEMPLATE_ID]: templateId,
        };
    }

    return parseResult;
};

export { xmlToPrinter, printVoToStandard, jsonToXml };
